module.exports = "//...\n\nconst MainApp = initialProps => (\n  <div>\n    <Route\n      path={\"/movie/:slug\"}\n      render={props => <MovieDetail {...props} {...initialProps} />}\n    />\n    <Route\n      path={\"/\"}\n      exact\n      render={props => <MovieList {...props} {...initialProps} />}\n    />\n  </div>\n);\n\n//..."


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/exercise-routing-list1.js.txt
// module id = 442
// module chunks = 211874487586253